import { useMemo, useState } from 'react';
import { StatusListInterface } from '../../../interfaces/ProjectInterface';
import DropdownItem from '../../dropdown/dropdownItem';
import Dropdown from '../../dropdown/mainDropdown';
import { renderStatusIconName } from '../../../helpers/common';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../../mobx/rootStore';
import IconButton from '../../button/iconButton';
import { CHIP_SIZE, CHIP_TYPE, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../global/constants';
import Chip from '../../chipComponent';

interface Props {
  isCreateTask?: boolean;
  statusList: StatusListInterface[];
  currentStatusId?: string;
  defaultStatus: StatusListInterface | undefined;
  isTaskCheckBox?: boolean;
  onUpdateStatus: (status: StatusListInterface, previousStatus: StatusListInterface) => void;
  isTemplateProject?: boolean;
  isIconButton?: boolean;
}
function TaskStatusDropdown(props: Props) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const {
    statusList,
    isCreateTask,
    currentStatusId,
    defaultStatus,
    onUpdateStatus,
    isTaskCheckBox,
    isTemplateProject = false,
    isIconButton = false
  } = props;

  //Mobx store variables
  const { projectTemplateStore } = rootStore;
  const { currentProjectTemplate } = projectTemplateStore;

  const currentStatus = statusList?.find((x) => x['_id'] === currentStatusId) || defaultStatus || statusList?.[0];

  const renderStatusList = useMemo(() => {
    const renderStatusList = (isTemplateProject ? currentProjectTemplate?.statusData : statusList) || [];
    return renderStatusList.map((status) => (
      <DropdownItem
        label={status.Name}
        iconName={renderStatusIconName(status.Type)}
        iconViewBox='0 0 16 16'
        key={status['_id']}
        onClick={() => onUpdateStatus(status, currentStatus)}
        isSelected={currentStatus?.['_id'] === status['_id']}
      />
    ));
  }, [currentProjectTemplate?.statusData, currentStatus, isTemplateProject, onUpdateStatus, statusList]);

  return (
    <Dropdown
      content={
        isIconButton ? (
          <IconButton
            iconName={renderStatusIconName(currentStatus?.Type)}
            variant={ICON_BUTTON_TYPE.TERTIARY}
            iconViewBox='0 0 16 16'
            size={isTaskCheckBox ? ICON_BUTTON_SIZE.SMALL : ICON_BUTTON_SIZE.MEDIUM}
            isMultiColor={true}
            className={isTaskCheckBox ? 'sub-task-icon' : isDropdownOpen ? 'active-status-dropdown' : ''}
            type={!isTaskCheckBox ? 'square' : 'rounded'}
          />
        ) : (
          <Chip
            size={isCreateTask ? CHIP_SIZE.SMALL : CHIP_SIZE.MEDIUM}
            title={currentStatus?.Name}
            leadingIconName={renderStatusIconName(currentStatus?.Type)}
            variant={isCreateTask ? CHIP_TYPE.FILL : CHIP_TYPE.EMPTY}
            leadingIconViewBox='0 0 16 16'
            isActive={isDropdownOpen}
            isMulticolorIcon={true}
          />
        )
      }
      trigger='click'
      modalTitle='Status'
      updateDropdownOpen={(isOpen) => setIsDropdownOpen(isOpen)}>
      {renderStatusList}
    </Dropdown>
  );
}
export default observer(TaskStatusDropdown);
